module.exports = __webpack_public_path__ + "img/twitter.3fd51ea0.svg";